import styling from '../core/styling.js';
import displayModes from '../core/displayModes';
const { supportedThemes } = styling;
const { Dark } = supportedThemes;
const clusterColorMap = new Map();

function Configure(displayMode, defaultColor, themeSpecificValue) {
    const { name } = displayMode;
    clusterColorMap[name] = defaultColor;

    if (!!themeSpecificValue && Array.isArray(themeSpecificValue)) {
        themeSpecificValue.forEach(themeMapping => {
            const themeName = themeMapping[0];
            const value = themeMapping[1];
            const key = `${name}-${themeName}`;
            clusterColorMap[key] = value;
        });
    }
}

Configure(displayModes.opacity, '#c50637', [[Dark, 'hsl(345, 78%, 20%)']]);
Configure(displayModes.revenue, '#0D6986', [[Dark, '#0c1e36']]);

Configure(displayModes.logcount, '#A3A6BA');
Configure(displayModes.sloViolation, '#A3A6BA');
Configure(displayModes.ttfb, [380, 'green', 400, 'orange', 800, 'orangered', 1200, 'red']);

Configure(displayModes.livePageRequests, [2, 'red', 10, 'orange', 15, 'orange', 20, 'green', 30, 'green']);


const getComputedStylesFor = (displayMode) => {
    const { name } = displayMode;
    if (!name) {
        const stringify = JSON.stringify(displayMode);
        throw new Error(`No mode name: ${stringify}`);
    }
    const lowered = name.toLowerCase();
    const modeNode = document.getElementById(`md-${lowered}`);
    if (modeNode) {
        return getComputedStyle(modeNode);
    }
    else {
        throw new Error(`${name} mode does not have associated dom element`);
    }
}

export const modeSpecificCssVariable = (displayMode, cssVariableName, defaultValue) => {
    let styles = getComputedStylesFor(displayMode);
    let value = styles.getPropertyValue(cssVariableName);
    if (!value) {
        styles = getComputedStyle(document.body);
        value = styles.getPropertyValue(cssVariableName);
    }
    return value || defaultValue || cssVariableName;
}

/*
* Resolves colors to be supplied to Azure map layer (likely bubble). 
*/
export const resolveThemeColorsForClusterAggregation = (displayMode) => {
    let { clusterColorScales, colorsFinalized } = displayMode;
    if (colorsFinalized) {
        // do nothing
    }
    else if (typeof clusterColorScales === "string" && clusterColorScales.startsWith('--')) {
        clusterColorScales = modeSpecificCssVariable(displayMode, clusterColorScales);
    }
    else if (Array.isArray(clusterColorScales)) {
        clusterColorScales.forEach((el, i) => {
            if (typeof (el) === 'string' && el.startsWith("--"))
            {
                clusterColorScales[i] = modeSpecificCssVariable(displayMode, el);
            }
            else {
                return null;
            }
        });
    }
    else if (!clusterColorScales) {
        clusterColorScales = modeSpecificCssVariable(displayMode, '--color-bubble', 'pink');
    }

    return clusterColorScales;
}

export const getFontColor = () => {
    const bodyStyle = getComputedStyle(document.body);
    const configuredFont = bodyStyle?.getPropertyValue('--text-font-color');
    return configuredFont ? configuredFont : 'black';
}

export const cssThemeColors = {
    transparent: ['rgba', 0, 0, 0, 0],
    ok: '--color-ok',
    medium: '--color-warn',
    slow: '--color-warn-warn',
    slowest: '--color-bad'
};

